export default __webpack_public_path__ + "static/media/ic_skills.d6751363.svg";